import EmailIcon from "@mui/icons-material/Email";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import { AppBar, Box, Button, Container, Paper, Stack, Toolbar, Typography } from "@mui/material";
import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Outlet } from "@tanstack/react-router";
import type { ReactNode } from "react";
import logo from "@/assets/logo.svg";
import ErrorCard from "@/components/ErrorCard";
import FullPageSpinner from "@/components/FullPageSpinner";

export type RootRouterContext = {
    queryClient: QueryClient;
};

const Root = (): ReactNode => {
    return (
        <Box sx={{ display: "flex", flexDirection: "column", minHeight: "100vh" }}>
            <AppBar position="static" color="inherit" variant="outlined">
                <Toolbar>
                    <img src={logo} height={24} alt="Clarity Logo" />
                    <Typography variant="h6" component="div" sx={{ ml: 2 }}>
                        Pricing API
                    </Typography>
                    <Typography component="div" sx={{ ml: 2 }}>
                        Access Token Request
                    </Typography>
                </Toolbar>
            </AppBar>
            <Box component="main" sx={{ py: 2, flexGrow: 1 }}>
                <Outlet />
            </Box>
            <Paper variant="outlined" sx={{ p: 2, bgcolor: "grey.100" }}>
                <Container maxWidth="md">
                    <Stack
                        spacing={2}
                        direction={{ xs: "column", md: "row" }}
                        justifyContent="space-between"
                        alignItems="center"
                    >
                        <Stack spacing={2} direction="row" alignItems="center">
                            <Button
                                component="a"
                                href="tel:+18773984266"
                                startIcon={<LocalPhoneIcon />}
                                color="inherit"
                            >
                                877.398.4266
                            </Button>

                            <Button
                                component="a"
                                href="mailto:client.support@diamondassets.com"
                                startIcon={<EmailIcon />}
                                color="inherit"
                            >
                                Support
                            </Button>
                        </Stack>

                        <Typography>Monday – Friday 8:00 am – 4:30 pm CST</Typography>
                    </Stack>
                </Container>
            </Paper>
        </Box>
    );
};

export const Route = createRootRouteWithContext<RootRouterContext>()({
    component: Root,
    pendingComponent: FullPageSpinner,
    errorComponent: ({ error }) => (
        <Container maxWidth="md" sx={{ my: 2 }}>
            <ErrorCard error={error} />
        </Container>
    ),
});
